export default {
  name: 'customRender',
  functional: true,
  props: {
    render: Function,
  },
  render: (h, ctx) => ctx.props.render(h),
};
